module.exports = __webpack_public_path__ + "img/cloud2.97a89b7f.png";